export default __webpack_public_path__ + "static/media/upland@2x.cf64118c.jpg";